// 落地页
export const enterLandingPage = '进入“落地页”';
export const landingPageReviveGift = '“开始收礼物吧”按钮';
export const loginByFB = '登录弹窗-“FB”';
export const loginByTwitter = '登录弹窗-“Twitter”';
export const loginByGoogle = '登录弹窗-“Google”';
export const loginByQQ = '登录弹窗-“QQ”';
export const loginByWeibo = '登录弹窗-“Weibo”';
export const loginByWeixin = '登录弹窗-“WeChat”';
export const loginByLine = '登录弹窗-“Line”';

// 创建礼物
export const enterCreateStepOne = '到达创建第一步';
export const createStepOneSave = '创建第一步~保存礼物面板';
export const enterCreateStepTwo = '到达创建第二步';
export const createStepTwoCopy = '创建第二步~复制链接';
export const createStepTwoSeeAll = '创建第二步~查看所有面板';
export const enterCreateStepThree = '到达创建第三步';
export const createStepThreeYoutube = 'Youtube 按钮';
export const createStepThreeInstagram = 'Instagram 按钮';
export const createStepThreeFacebook = 'Facebook 按钮';
export const createStepThreeCreateNew = '创建第三步~“创建新的礼物面板”按钮';
export const createStepThreeRevenue = '创建第三步~“查看收益”按钮';

// 送礼页面
export const enterGiftoSendPage = '到达送礼页面';
export const giftoBoardSendButton = '送礼页面~“发送”／“Send”按钮';
export const giftoBoardRank = '送礼页面~左上角榜单';
export const giftoBoardSendMore = '送礼页面~礼物批量赠送';
export const giftoBoardRecharge = '送礼页面~“充值”／“Charge”按钮';
export const giftoSendList = '查看面板的送礼流水';

// 个人主页
export const enterProfilePage = '到达个人主页';
export const profilePageRevenue = '个人主页~查看收益';
export const profilePageGIFTO = '个人主页~查看GIFTO';

// 收益页面
export const enterRevenuePage = '到达收益页面';
export const revenuePageGiftoRank = '收益页面~礼物榜单';
export const revenuePageUserRank = '收益页面~用户榜单';

// 项目列表
export const enterDashboardPage = '到达项目列表页面';
export const dashboardPageCreate = '项目列表页面~创建礼物面板按钮';
export const dashboardPageCopy = '项目列表页面~复制链接按钮';
export const dashboardPageMessage = '项目列表页面~私信按钮';



// WEBPACK FOOTER //
// ./js/ga-config.js